var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29228",
    "data-name": "Group 29228",
    transform: "translate(583 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -10575)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_10_",
    "data-name": "svgexport-17 (10)",
    transform: "translate(-567.475 -10551.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50470",
    "data-name": "Path 50470",
    d: "M29.225,7.489a.452.452,0,0,1-.4-.236,9.629,9.629,0,0,0-3.706-4.1.419.419,0,0,0-.2-.047H23.858c1.094.851,2.579,2.255,2.882,3.848a.452.452,0,0,1-.878.169c-.405-2.133-3.645-4.057-3.679-4.077a.452.452,0,0,1,.223-.837h2.518a1.252,1.252,0,0,1,.587.135,10.4,10.4,0,0,1,4.1,4.476.452.452,0,0,1-.392.675ZM1.386,9.642H.765a.452.452,0,0,1,0-.9h.621a.972.972,0,0,0,.972-.972V7.131a.452.452,0,1,1,.9,0v.641a1.877,1.877,0,0,1-1.877,1.87ZM40.95,11.188H39.2a2.666,2.666,0,0,1-2.66-2.666V8.13a.452.452,0,0,1,.9,0v.392A1.763,1.763,0,0,0,39.2,10.283h1.755a.452.452,0,1,1,0,.9Zm-31.457,1.3a2.538,2.538,0,1,0,2.538,2.538A2.538,2.538,0,0,0,9.494,12.484Zm0,5.974a3.443,3.443,0,1,1,3.443-3.443A3.443,3.443,0,0,1,9.494,18.458Zm23.829-5.974a2.542,2.542,0,1,0,.007,0Zm0,5.974a3.443,3.443,0,1,1,3.449-3.436,3.443,3.443,0,0,1-3.449,3.436Z",
    transform: "translate(0.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50471",
    "data-name": "Path 50471",
    d: "M36.366,12.844a.452.452,0,1,1,0-.9c3.065-.013,3.692-.034,3.794-.047.432-.068.513-.277.527-.344V10.029c.014-2.241-.338-2.585-.506-2.747l-.054-.054c-1.364-1.4-7.844-2.268-10.861-2.4H8.493a1.1,1.1,0,0,1-.79-.331l-.655-.655a.878.878,0,0,0-1.013-.182l-.763.351c-.743.338-1.519.689-2.025.878a.459.459,0,0,1-.162.027H1.5a.23.23,0,0,0-.236.236V9.975c-.007.979.486,1.141.567,1.161l.068.014,2.3.743H6.556a.452.452,0,1,1,0,.9L4.119,12.79a.445.445,0,0,1-.135-.02l-2.342-.756C1.169,11.919.352,11.386.359,9.969V5.149A1.138,1.138,0,0,1,1.5,4.015H3c.486-.182,1.2-.513,1.89-.824l.776-.358A1.789,1.789,0,0,1,7.676,3.2l.655.655a.2.2,0,0,0,.155.068H29.3c1.836.081,9.667.81,11.476,2.673l.034.041c.405.392.79.972.783,3.389v1.58a1.381,1.381,0,0,1-1.3,1.175C40.207,12.8,40.024,12.824,36.366,12.844Zm-5.974,0c-4.577,0-10.585,0-17.862-.027a.452.452,0,0,1,0-.9c7.277.02,13.292.034,17.862.034a.452.452,0,1,1,0,.9Z",
    transform: "translate(0 2.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50472",
    "data-name": "Path 50472",
    d: "M7.853,12.073H.812a.452.452,0,1,1,0-.9H7.853a.452.452,0,0,1,0,.9Zm23.836,0H11.221a.452.452,0,1,1,0-.9H31.689a.452.452,0,0,1,0,.9Zm9.451,0H35.057a.452.452,0,1,1,0-.9h6.075a.452.452,0,0,1,0,.9Zm-20.4-3.355H19.8a.452.452,0,0,1,0-.9h.932a.452.452,0,0,1,0,.9Zm-11.2,4.7a.672.672,0,1,0,0-.007Zm0,2.241a1.573,1.573,0,1,1,1.573-1.573A1.573,1.573,0,0,1,9.541,15.658ZM33.37,13.417a.672.672,0,1,0,0-.007Zm0,2.241a1.573,1.573,0,1,1,1.573-1.573A1.573,1.573,0,0,1,33.37,15.658ZM18.019,6.552a.452.452,0,0,1-.439-.358l-.452-2.12c-.041-.189-.2-.8-.716-.8a.837.837,0,0,0-.621.29.346.346,0,0,0-.095.317l.452,2.126a.452.452,0,1,1-.878.182l-.466-2.12a1.269,1.269,0,0,1,.277-1.08,1.735,1.735,0,0,1,1.323-.621,1.692,1.692,0,0,1,1.6,1.512l.446,2.126a.452.452,0,0,1-.439.54Z",
    transform: "translate(0.006 0.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50473",
    "data-name": "Path 50473",
    d: "M17.227,4.061h-9.5a1.1,1.1,0,0,1-.79-.331l-.655-.655a.878.878,0,0,0-1.013-.182L4.5,3.244c-.716.324-1.451.662-1.958.851v.25A1.877,1.877,0,0,1,.669,6.214H.493V8.678H6.96a3.416,3.416,0,0,1,3.625,0H30.8a3.416,3.416,0,0,1,3.625,0h5.488q-.01-.46-.061-.918H38.484a2.666,2.666,0,0,1-2.66-2.666V5.06a45.815,45.815,0,0,0-7.344-.992h-11.2a.412.412,0,0,1-.054,0ZM19.05,6.228a.452.452,0,0,1,0-.9h.925a.452.452,0,0,1,0,.9h-.938Z",
    transform: "translate(0.771 3.428)",
    fill: "#ffe600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50474",
    "data-name": "Path 50474",
    d: "M.669,4.173A.972.972,0,0,0,1.641,3.2v-.2H.729a.23.23,0,0,0-.236.236v.932H.675Z",
    transform: "translate(0.771 4.571)",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50475",
    "data-name": "Path 50475",
    d: "M5.972,3.816H.5c.095.648.473.77.54.79l.068.014,2.3.743H5.344a3.416,3.416,0,0,1,.628-1.553Z",
    transform: "translate(0.794 9.195)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50476",
    "data-name": "Path 50476",
    d: "M6.414,6.176a2.538,2.538,0,0,0-5.07-.034v.02a2.538,2.538,0,0,0,5.07.007ZM3.882,4.59a1.575,1.575,0,1,1-.007,0Z",
    transform: "translate(5.664 8.86)",
    fill: "#a39e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50477",
    "data-name": "Path 50477",
    d: "M2.137,3.816a3.416,3.416,0,0,1,.628,1.573l17.018.034a3.416,3.416,0,0,1,.635-1.613H2.13Z",
    transform: "translate(10.184 9.195)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50478",
    "data-name": "Path 50478",
    d: "M2.966,4.74a.675.675,0,1,0-.672.608A.675.675,0,0,0,2.966,4.74Zm23.161-.668a.671.671,0,1,0,0-.007Z",
    transform: "translate(7.248 10.282)",
    fill: "#d1c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50479",
    "data-name": "Path 50479",
    d: "M7.412,4.7A1.573,1.573,0,1,1,5.839,6.27,1.573,1.573,0,0,1,7.412,4.7Zm0,4.111A2.538,2.538,0,0,0,9.95,6.31q0-.02,0-.04A2.538,2.538,0,1,0,7.412,8.808Z",
    transform: "translate(25.963 8.752)",
    fill: "#a39e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50480",
    "data-name": "Path 50480",
    d: "M5.662,3.816A3.355,3.355,0,0,1,6.3,5.409C9,5.4,9.57,5.375,9.672,5.362c.425-.068.506-.277.52-.344V3.809H5.669Z",
    transform: "translate(30.494 9.195)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50481",
    "data-name": "Path 50481",
    d: "M5.862,3.173A1.762,1.762,0,0,0,7.617,4.746H8.765a.968.968,0,0,0-.23-.338l-.054-.054A6.341,6.341,0,0,0,5.862,3.173Z",
    transform: "translate(31.645 5.538)",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50482",
    "data-name": "Path 50482",
    d: "M4.408,4.883,4.071,3.3c-.041-.189-.2-.8-.716-.8a.837.837,0,0,0-.621.29.346.346,0,0,0-.095.317l.371,1.769h1.4Z",
    transform: "translate(13.063 1.708)",
    fill: "#7d9dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50483",
    "data-name": "Path 50483",
    d: "M3.848,2.343A7.872,7.872,0,0,1,6.643,5.826H8.432A8.961,8.961,0,0,0,5.11,2.384a.419.419,0,0,0-.2-.041Z",
    transform: "translate(20.063 0.765)",
    fill: "#4cf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertible);
export default __webpack_public_path__ + "static/media/convertible.0d5903c5a104c740bf8535136316a264.svg";
export { ForwardRef as ReactComponent };